import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ShowContentDialogData
{
  title: string;
  text: string;
  content: string
}

@Component({
    selector: 'app-show-content-dialog',
    templateUrl: './show-content-dialog.component.html',
    styleUrl: './show-content-dialog.component.scss',
    standalone: false
})
export class ShowContentDialogComponent {
  dialogRef = inject<MatDialogRef<ShowContentDialogComponent>>(MatDialogRef);
  data = inject<ShowContentDialogData>(MAT_DIALOG_DATA);
}
